module.exports = __webpack_public_path__ + "img/clampsBold.c542108b.svg";